import React, { FC } from 'react';

import { CardFooter, ButtonClear } from './styles';

interface Props {
  onClear: () => void;
}

export const ClearButton: FC<Props> = ({ onClear }: Props) => (
  <CardFooter className="filter-card-footer">
    <ButtonClear variant="light" className="filter-footer-clear-btn" onClick={onClear}>
      Clear
    </ButtonClear>
  </CardFooter>
);
